import React from "react";
import ton from "../../assets/ton.png";
import sol from "../../assets/sol.png";
import btc from "../../assets/btc.png";
import eth from "../../assets/eth.png";
import eos from "../../assets/eos.png";
import { getCurrentUrl, navigate } from "./../utilities";
function ValidationsBlock(props: any) {
  const {
    validations: { document },
  } = props;
  return (
    <div className="GenericWrapper">
      <div className="Body">
        {document.validations.map((e: any) => {
          return (
            <BlockChainLogo
              docName={document.name}
              leafHash={document.hash}
              key={e.blockchain}
              type={e.blockchain}
              BB={props.BB || false}
              data={e}
            />
          );
        })}
      </div>
    </div>
  );
}

export function BlockChainLogo(props: any) {
  const Logos: any = {
    Ton: ton,
    Solana: sol,
    Bitcoin: btc,
    EOS: eos,
    Ethereum: eth,
  };
  let type = props.type;
  let img = Logos[type as any];
  let blockUrl = props.BB
    ? `${getCurrentUrl()}/?blockBBHash=${
        props?.data?.blockHash
      }&leafHash=${encodeURIComponent(props.leafHash || "")}`
    : `${getCurrentUrl()}/?blockHash=${
        props?.data?.blockHash
      }&blockchain=${type}&id=${props.docName}`;
  // Keep <a href> for accessibility + cmd/ctrl+click open-in-new-tab, but
  // intercept the regular left-click to do a soft SPA navigation.
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.defaultPrevented) return;
    if (
      e.button !== 0 ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey
    )
      return;
    e.preventDefault();
    navigate(blockUrl);
  };

  return (
    <a href={blockUrl} onClick={handleClick}>
      <img
        title={type}
        src={img}
        alt=""
        draggable="false"
        className="ValidationLogo"
      />
    </a>
  );
}

export default ValidationsBlock;
